import { TextInput, styled } from '@volkswagen-onehub/components-core';
import { Magnifier } from '@volkswagen-onehub/icons-core';
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react';
import Data from './Data';
import Footers from '../Footers';
import { useAppSelector } from '../../../../store/hooks';
import { TimelineData } from '../../../../types/timeline';
import { useFeatureServices } from '../../../../use-feature-services';
import { Language } from '../../../../types/language';
import useTrans from '../../../../hooks/use-trans';
import { windowScroll } from '../../../../utils/utils';

const TimelinesContainer = styled.div`
    margin-top: ${props => props.theme.size.dynamic0040};
    display: flex;
    flex-direction: column;
    row-gap: ${props => props.theme.size.dynamic0100};
`;

const SearchController = styled.div``;

export default () => {
    const [data, setData] = useState<TimelineData | null>(null);

    const timeline = useAppSelector(state => state.timeline.value);
    const lang = useFeatureServices()['locale-service'].language as Language;
    const trans = useTrans();

    const searchRef = useRef<HTMLDivElement | null>(null);

    const onSearch = (e : SyntheticEvent<HTMLInputElement, Event>) => {
        const search = e.currentTarget.value;

        const timelineData = getTimelineData();

        if(search) {
            if(timelineData) {
                const filteredData =  Object.keys(timelineData)
                    .filter(key => key)
                    .reduce((obj : TimelineData, key:string) => {
                        obj[key] = timelineData[key].filter(detail => detail.toLowerCase().includes(search));
                        return obj;
                    }, {})

                setData(filteredData);
            }
        }
        else {
            setData(timelineData);
        }
    }

    const getTimelineData = () => {
        let timelineData : TimelineData | null = null;

        if(timeline) {
            const key = Number(Object.keys(timeline)[0]);
            timelineData = timeline[key][lang];
        }

        return timelineData;
    }

    useEffect(() => {
        if(!timeline) return;
        setData(getTimelineData());

        windowScroll(searchRef.current?.parentElement?.offsetTop);

    }, [timeline]);

    return timeline && (
        <TimelinesContainer>
            <SearchController ref={searchRef}>
                <TextInput type="search" placeholder={trans.result_search_text} icon={<Magnifier variant="default" ariaHidden />} onChange={e => onSearch(e)} />
            </SearchController>

            {data && Object.keys(data).map( k => <Data data={data[k]} title={k} key={k} />) }

            <Footers />
        </TimelinesContainer>
    );
}